import { apiClient } from '../api/apiClient';

export const adminService = {
    getStats() {
        return apiClient.get('admin/stats');
    },

    getUsers(params) {
        return apiClient.get(`admin/users?${params.toString()}`);
    },

    toggleUserAdmin(userId) {
        return apiClient.request(`admin/users/${userId}/toggle-admin`, {
            method: 'PATCH'
        });
    },

    toggleUserVerified(userId) {
        return apiClient.request(`admin/users/${userId}/toggle-verified`, {
            method: 'PATCH'
        });
    },

    updateUserDetails(userId, payload) {
        return apiClient.put(`admin/users/${userId}/details`, { json: payload });
    },

    sendTargetedCommunication(payload) {
        return apiClient.post('admin/users/targeted-communication', { json: payload });
    },

    deleteUser(userId) {
        return apiClient.del(`admin/users/${userId}`);
    },

    getBanners() {
        return apiClient.get('admin/banners');
    },

    getActiveBanners() {
        return apiClient.get('admin/banners/active');
    },

    createBanner(payload) {
        return apiClient.post('admin/banners', { json: payload });
    },

    updateBanner(bannerId, payload) {
        return apiClient.put(`admin/banners/${bannerId}`, { json: payload });
    },

    deleteBanner(bannerId) {
        return apiClient.del(`admin/banners/${bannerId}`);
    },

    toggleBanner(bannerId) {
        return apiClient.request(`admin/banners/${bannerId}/toggle`, {
            method: 'PATCH'
        });
    },

    getEquipmentCategories() {
        return apiClient.get('admin/equipment/categories');
    },

    createEquipmentCategory(payload) {
        return apiClient.post('admin/equipment/categories', { json: payload });
    },

    updateEquipmentCategory(categoryId, payload) {
        return apiClient.put(`admin/equipment/categories/${categoryId}`, { json: payload });
    },

    getEquipmentBrands(categoryId) {
        const query = categoryId ? `?categoryId=${categoryId}` : '';
        return apiClient.get(`admin/equipment/brands${query}`);
    },

    createEquipmentBrand(payload) {
        return apiClient.post('admin/equipment/brands', { json: payload });
    },

    updateEquipmentBrand(brandId, payload) {
        return apiClient.put(`admin/equipment/brands/${brandId}`, { json: payload });
    },

    getEquipmentSpecifications(categoryId) {
        const query = categoryId ? `?categoryId=${categoryId}` : '';
        return apiClient.get(`admin/equipment/specifications${query}`);
    },

    createEquipmentSpecification(payload) {
        return apiClient.post('admin/equipment/specifications', { json: payload });
    },

    updateEquipmentSpecification(definitionId, payload) {
        return apiClient.put(`admin/equipment/specifications/${definitionId}`, { json: payload });
    },

    getPerks(params) {
        return apiClient.get(`admin/perks?${params.toString()}`);
    },

    togglePerkActive(perkId) {
        return apiClient.request(`admin/perks/${perkId}/toggle-active`, {
            method: 'PATCH'
        });
    },

    togglePerkFeatured(perkId) {
        return apiClient.request(`admin/perks/${perkId}/toggle-featured`, {
            method: 'PATCH'
        });
    },

    deletePerk(perkId) {
        return apiClient.del(`admin/perks/${perkId}`);
    },

    createSupplierPerk(payload) {
        return apiClient.post('admin/supplier-perks', { json: payload });
    },

    getSupplierNames() {
        return apiClient.get('admin/supplier-perks/suppliers');
    },

    toggleSupplierPerkActive(perkId) {
        return apiClient.request(`admin/supplier-perks/${perkId}/toggle-active`, {
            method: 'PATCH'
        });
    },

    toggleSupplierPerkFeatured(perkId) {
        return apiClient.request(`admin/supplier-perks/${perkId}/toggle-featured`, {
            method: 'PATCH'
        });
    },

    deleteSupplierPerk(perkId) {
        return apiClient.del(`admin/supplier-perks/${perkId}`);
    },

    getMarketplaceListings(params) {
        return apiClient.get(`admin/marketplace/listings?${params.toString()}`);
    },

    updateMarketplaceListingStatus(listingId, payload) {
        return apiClient.request(`admin/marketplace/listings/${listingId}/status`, {
            method: 'PATCH',
            json: payload
        });
    },

    deleteMarketplaceListing(listingId) {
        return apiClient.del(`admin/marketplace/listings/${listingId}`);
    },

    getMarketplaceOffers(params) {
        return apiClient.get(`admin/marketplace/offers?${params.toString()}`);
    },

    updateMarketplaceOfferStatus(offerId, payload) {
        return apiClient.request(`admin/marketplace/offers/${offerId}/status`, {
            method: 'PATCH',
            json: payload
        });
    }
};
